import { render } from "./CheckPageManager.vue?vue&type=template&id=a47e822c"
import script from "./CheckPageManager.vue?vue&type=script&lang=js"
export * from "./CheckPageManager.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__